import * as _actions from './actions';
import _reducer, {
  academicInfoConcernsStudentSkills as _academicInfoConcernsStudentSkills,
} from './reducer';

export const actions = _actions;
export const reducer = _reducer;
export const academicInfoConcernsStudentSkills = _academicInfoConcernsStudentSkills;



// WEBPACK FOOTER //
// ./data/AcademicInfo/Summary/index.js